import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

export const BrokerCard = ({ broker }) => {
  return (
    <div
      className="bg-white border border-slate-200 rounded-xl p-6 flex flex-col h-full hover:border-slate-300 hover:shadow-sm transition-all duration-200"
      data-testid={`broker-card-${broker.slug}`}
    >
      <div className="flex items-center justify-center h-14 mb-4">
        <span className="text-lg font-bold tracking-tight text-slate-900 font-['Outfit'] uppercase text-center">
          {broker.name}
        </span>
      </div>

      <p className="text-sm text-slate-600 leading-relaxed mb-4 flex-grow line-clamp-3">
        {broker.short_description}
      </p>

      <div className="space-y-2 mb-5 text-xs text-slate-500">
        <div className="flex justify-between">
          <span>Regulation</span>
          <span className="font-medium text-slate-700 text-right max-w-[60%] truncate">{broker.regulation}</span>
        </div>
        <div className="flex justify-between">
          <span>Min. Deposit</span>
          <span className="font-medium text-slate-700">{broker.min_deposit}</span>
        </div>
        <div className="flex justify-between">
          <span>Platforms</span>
          <span className="font-medium text-slate-700 text-right max-w-[60%] truncate">{broker.platforms}</span>
        </div>
      </div>

      <div className="flex flex-col gap-2 mt-auto">
        <Link
          to={`/${broker.slug}`}
          className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors bg-blue-600 text-white hover:bg-blue-700 h-9 px-4"
          data-testid={`read-review-${broker.slug}`}
        >
          Read Review
        </Link>
        <a
          href={broker.affiliate_url}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="inline-flex items-center justify-center gap-1.5 rounded-md text-sm font-medium transition-colors bg-blue-50 border border-blue-200 text-blue-700 hover:bg-blue-100 h-9 px-4"
          data-testid={`visit-website-${broker.slug}`}
        >
          Visit Website <ExternalLink className="w-3.5 h-3.5" />
        </a>
        <p className="text-[10px] text-slate-400 text-center leading-tight">
          This link may be an affiliate link. We may receive compensation if you register through it.
        </p>
        <p className="text-[10px] text-red-500 text-center leading-tight">
          Trading leveraged financial instruments involves a high level of risk.
        </p>
      </div>
    </div>
  );
};
